// Shared uppercase caption for filter fields and small section labels.
//
// The single source for the small uppercase caption look: 12px, semibold,
// tracked, ink-colored (readable on a light surface; the darkened ink token
// carries the contrast). Replaces the assorted text-[10px] font-bold
// uppercase ad-hoc labels that drifted in size and color across pages.
// Size raised from 11px to 12px (approved darker/larger type pass, 2026-06).

import type { ReactNode } from 'react';

export const FILTER_LABEL_CLS =
  'mb-1 block text-[12px] font-semibold uppercase tracking-caps-pill text-amp-ink dark:text-amp-dark-ink-muted';

type Props = {
  children: ReactNode;
  /** Render as a <label> (default) or a plain <div> for non-field captions. */
  as?: 'label' | 'div';
  htmlFor?: string;
  className?: string;
};

export function FilterLabel({ children, as = 'label', htmlFor, className }: Props) {
  const cls = `${FILTER_LABEL_CLS}${className ? ` ${className}` : ''}`;
  if (as === 'div') {
    return <div className={cls}>{children}</div>;
  }
  return (
    <label className={cls} htmlFor={htmlFor}>
      {children}
    </label>
  );
}
